module.exports = __webpack_public_path__ + "static/img/258_TO8_2321.47b23d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/258_TO8_2321.jpg
// module id = lk0o
// module chunks = 0